import * as joi from "joi";

export const substatusDataSchema = joi.object().keys({
  statusName: joi.string().trim().required(),
});
